import classNames from 'classnames';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { ProjectName } from 'CONFIG_TYPES';

import { LogoIcon } from '../Pages/Components/LogoIcon/LogoIcon';
import styles from './LinkExpired.styles.m.css';

export const LinkExpired: FC = () => {
  const { t } = useTranslation();
  const isShowLogo = PROJECT_NAME === ProjectName.Gemteam;

  return (
    <div className={styles.container}>
      <LogoIcon className={classNames(styles.logo, { [styles.logoShow]: isShowLogo })} />
      <h1 className={styles.title}>{t('call_expired_link')}</h1>
      <p className={styles.subTitle}>{t('call_expired_link_hint')}</p>
    </div>
  );
};
